/**
 * The longest message body (and selected fragment) a compose request accepts, in characters.
 * The composer reads it too: a selection rewrite of a longer draft falls back to sending the
 * fragment alone instead of a request the server would reject.
 */
export const COMPOSE_MESSAGE_BODY_MAX_LENGTH = 24_000;
